import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import Layout from '../components/Layout';
import { T } from '../styles/theme';
import { useIsMobile } from '../hooks/useIsMobile';

const categorieBadge = {
  Abbigliamento: { bg: '#1e3a5f', color: '#60a5fa' },
  Scarpe: { bg: '#3b2f0a', color: T.amber },
  Elettronica: { bg: '#2d1b4e', color: '#c084fc' },
  Accessori: { bg: '#1a3329', color: T.green },
  Borse: { bg: '#3b2a1a', color: '#fb923c' },
  Orologi: { bg: '#1a2e3b', color: '#22d3ee' },
  Profumi: { bg: '#3b1a3b', color: '#f472b6' },
  Altro: { bg: '#3b1c1c', color: T.red },
};

function ProLock() {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="w-20 h-20 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: T.border }}>
        <svg className="w-10 h-10" fill="none" stroke={T.violet} strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
        </svg>
      </div>
      <h2 className="section-title mb-2">Contenuto riservato ai Pro</h2>
      <p className="text-sm mb-6 text-center max-w-md" style={{ color: T.muted, fontFamily: T.fontBody }}>Questa sezione è riservata agli abbonati Pro. Passa a Pro per accedere alla lista fornitori verificati.</p>
      <Link to="/profilo" className="px-6 py-3 rounded-xl font-bold text-sm transition-opacity hover:opacity-90" style={{ background: 'linear-gradient(135deg, #d97706, #f59e0b)', color: 'white' }}>
        Passa a Pro
      </Link>
    </div>
  );
}

export default function FornitoriPage() {
  const [fornitori, setFornitori] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locked, setLocked] = useState(false);
  const [corsoLocked, setCorsoLocked] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    api.get('/corso/check-modulo1').then((r) => {
      if (!r.data.modulo1_completo) { setCorsoLocked(true); setLoading(false); return; }
      api.get('/fornitori').then((r2) => setFornitori(r2.data)).catch((e) => {
        if (e.response?.status === 403) setLocked(true);
      }).finally(() => setLoading(false));
    }).catch(() => {
      api.get('/fornitori').then((r) => setFornitori(r.data)).catch((e) => {
        if (e.response?.status === 403) setLocked(true);
      }).finally(() => setLoading(false));
    });
  }, []);

  return (
    <Layout>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" style={{ fontFamily: T.fontBody }}>
        <div className="mb-6">
          <h1 className="page-title">Fornitori</h1>
          <p className="text-sm mt-1" style={{ color: T.muted }}>Fornitori verificati per il tuo business</p>
        </div>

        {loading ? (
          <div className="text-center py-16" style={{ color: T.muted }}>Caricamento...</div>
        ) : corsoLocked ? (
          <div className="card rounded-2xl">
            <div className="flex flex-col items-center justify-center py-20 px-4">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: T.border }}>
                <span className="text-4xl">🎓</span>
              </div>
              <h2 className="section-title mb-2">Prima completa il Modulo 1</h2>
              <p className="text-sm mb-6 text-center max-w-md" style={{ color: T.muted }}>Completa il Modulo 1 del corso per sbloccare la sezione Fornitori.</p>
              <Link to="/corso" className="btn-primary px-6 py-3 rounded-xl font-bold text-sm">Vai al Corso</Link>
            </div>
          </div>
        ) : locked ? (
          <div className="card rounded-2xl"><ProLock /></div>
        ) : fornitori.length === 0 ? (
          <div className="card text-center py-16 rounded-2xl">
            <p className="text-lg" style={{ color: T.muted }}>Nessun fornitore disponibile</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', gap: isMobile ? 8 : 16, marginTop: 16 }}>
            {fornitori.map((f) => {
              const cats = (f.categoria || '').split(',').map((c) => c.trim()).filter(Boolean);
              return (
                <div key={f.id} style={{
                  background: '#151230', border: '1px solid #2d1b69', borderRadius: 14,
                  padding: isMobile ? 12 : 20, display: 'flex', flexDirection: 'column', gap: 8,
                  transition: 'border-color 0.2s, transform 0.2s',
                }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = T.borderActive; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#2d1b69'; e.currentTarget.style.transform = ''; }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: isMobile ? '0.85rem' : '1rem', color: '#e2e8f0' }}>{f.nome}</span>
                    <span style={{
                      fontSize: '0.58rem', padding: '1px 7px', borderRadius: 9999, fontWeight: 700,
                      background: f.paese === 'estero' ? 'rgba(251,191,36,0.15)' : 'rgba(74,222,128,0.15)',
                      border: `1px solid ${f.paese === 'estero' ? T.amber + '50' : T.green + '50'}`,
                      color: f.paese === 'estero' ? T.amber : T.green,
                    }}>{f.paese === 'estero' ? 'ESTERO' : 'IT'}</span>
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {cats.map((cat) => {
                      const b = categorieBadge[cat] || { bg: T.border, color: T.violet };
                      return (
                        <span key={cat} style={{
                          fontSize: isMobile ? '0.6rem' : '0.72rem', padding: '2px 8px', borderRadius: 9999,
                          background: b.bg, border: `1px solid ${b.color}`, color: b.color,
                          display: 'inline-block', fontWeight: 700,
                        }}>{cat}</span>
                      );
                    })}
                  </div>
                  <p style={{ color: T.muted, fontSize: isMobile ? '0.72rem' : '0.85rem', flex: 1, lineHeight: 1.5 }}>{f.descrizione}</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 'auto' }}>
                    {f.link_whatsapp && (
                      <a href={f.link_whatsapp} target="_blank" rel="noopener noreferrer"
                        style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                          background: '#25D366', color: 'white', borderRadius: 9999,
                          padding: isMobile ? '8px 10px' : '10px 16px',
                          fontSize: isMobile ? '0.72rem' : '0.85rem', fontWeight: 600,
                          textDecoration: 'none',
                        }}>
                        📱 {isMobile ? 'WhatsApp' : 'Contatta su WhatsApp'}
                      </a>
                    )}
                    {f.telegram_tag && (
                      <a href={`https://t.me/${f.telegram_tag.replace('@', '')}`} target="_blank" rel="noopener noreferrer"
                        style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                          background: '#0088cc', color: 'white', borderRadius: 9999,
                          padding: isMobile ? '8px 10px' : '10px 16px',
                          fontSize: isMobile ? '0.72rem' : '0.85rem', fontWeight: 600,
                          textDecoration: 'none',
                        }}>
                        ✈️ {isMobile ? f.telegram_tag : `Telegram ${f.telegram_tag}`}
                      </a>
                    )}
                    {f.telegram_canale && (
                      <a href={f.telegram_canale} target="_blank" rel="noopener noreferrer"
                        style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                          background: 'rgba(0,136,204,0.15)', color: '#38bdf8', borderRadius: 9999,
                          border: '1px solid rgba(0,136,204,0.3)',
                          padding: isMobile ? '8px 10px' : '10px 16px',
                          fontSize: isMobile ? '0.72rem' : '0.85rem', fontWeight: 600,
                          textDecoration: 'none',
                        }}>
                        📢 {isMobile ? 'Canale TG' : 'Canale Telegram'}
                      </a>
                    )}
                    {f.telegram_spot && (
                      <a href={f.telegram_spot} target="_blank" rel="noopener noreferrer"
                        style={{
                          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                          background: 'rgba(167,139,250,0.12)', color: '#a78bfa', borderRadius: 9999,
                          border: '1px solid rgba(167,139,250,0.3)',
                          padding: isMobile ? '8px 10px' : '10px 16px',
                          fontSize: isMobile ? '0.72rem' : '0.85rem', fontWeight: 600,
                          textDecoration: 'none',
                        }}>
                        ⭐ {isMobile ? 'Spot TG' : 'Spot Canale Telegram'}
                      </a>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </main>    </Layout>
  );
}
